import { Usr_Cfg } from '../models/domain/usr_cfg';

export class Usr_CfgFactory {
    private static instance: Usr_CfgFactory;

    usr_Cfgs: Array<Usr_Cfg>;
    usr_CfgsCopy: Array<Usr_Cfg>;
    themeCode: string;

    static getInstance() {
        if (!Usr_CfgFactory.instance) {
            Usr_CfgFactory.instance = new Usr_CfgFactory();
        }

        return Usr_CfgFactory.instance;
    }

    constructor() {
        this.usr_Cfgs = new Array<Usr_Cfg>();
        this.usr_CfgsCopy = new Array<Usr_Cfg>();
        this.themeCode = '';
    }

    packUsr_Cfgs(usr_CfgsTmp: Array<Usr_Cfg>): void {
        this.usr_Cfgs = usr_CfgsTmp;
        for (let i: number = 0; i < usr_CfgsTmp.length; i++) {
            this.usr_CfgsCopy.push(Usr_Cfg.parse(usr_CfgsTmp[i]));
        }
    }
}
